import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
    Tokens,
    Token,
    ChainId,
    TokenLists,
    NETWORK_CONFIG,
} from '../../constants';

import { Container } from '@mui/material';

import GoBackImg from '@/assets/images/go_back.png';
import Modal from '@/components/Modal';

import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { TYPE } from '@/theme';
import DropdownIcon from '@/assets/images/svg/dropdown.svg?react';

interface Props {
    chainId: ChainId;
    setChainId: (chainId: ChainId) => void;
    chains?: ChainId[];
}

const StyledContainer = styled(Container)`
    width: 464px;
    height: fit-content;
    max-height: 90vh;
    margin: 0 auto;
    border-radius: 16px;
    padding: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    `}
`;

const NetworkWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 40px;
    flex-grow: 0;
    box-sizing: border-box;
    width: fit-content;
    height: 100%;
    gap: 4px;
    cursor: pointer;

    ${({ theme }) => theme.mediaWidth.upToSmall`
     gap: 4px;
    `};
    .logo {
        width: 35px;
        height: 35px;

        ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 20px;
        height: 20px;
        border-radius: 10px;
        `};
    }
`;

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 30px;
    padding-top: 40px;
`;

const NetworkItem = styled.div`
    height: 60px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        background: ${({ theme }) => theme.c.bg04};
    }

    img {
        width: 40px;
        height: 40px;
        border-radius: 20px;
    }
`;

const StyledDropdownIcon = styled(DropdownIcon)`
    width: 14px;
    height: 10px;
    color: #00cfff;

    ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 10px;
    height: 8px;
    `};
`;

export default function NetworkSelect({
    chainId,
    setChainId,
    chains = process.env.VITE_IS_MAINNET
        ? [ChainId.mainnet, ChainId.metisMainnet, ChainId.goatedMainnet]
        : [
              ChainId.metisMainnet,
              ChainId.metisTestnet,
              ChainId.goatedMainnet,
              ChainId.mainnet,
              ChainId.testnet,
          ],
}: Props) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <NetworkWrapper onClick={() => setIsOpen(true)}>
                <img
                    className="logo"
                    src={NETWORK_CONFIG[chainId].img}
                    alt={NETWORK_CONFIG[chainId].name}
                />
                <TYPE.main className="name" mobileFz={12}>
                    {NETWORK_CONFIG[chainId].name}
                </TYPE.main>
                <StyledDropdownIcon />
            </NetworkWrapper>
            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                // customContentClass={style.content}
            >
                <StyledContainer>
                    <TYPE.main textAlign={'center'} fontSize={20}>
                        Choose a network
                    </TYPE.main>
                    <List>
                        {chains.map((item) => (
                            <NetworkItem
                                key={item}
                                onClick={() => {
                                    setChainId(item);
                                    setIsOpen(false);
                                }}
                            >
                                <img
                                    src={NETWORK_CONFIG[item].img}
                                    alt={NETWORK_CONFIG[item].name}
                                />
                                <TYPE.main>
                                    {NETWORK_CONFIG[item].name}
                                </TYPE.main>
                            </NetworkItem>
                        ))}
                    </List>
                </StyledContainer>
            </Modal>
        </>
    );
}
